import { ImportProcess } from '../../../nacre/importController';

export default class AttendeeImportProcess extends ImportProcess {
    constructor(...args) {
        super(...args);
        this._rates_update =
            this._data?.rates_details?.map(r => ({
                from: r.rate_id || { name: r.rate_name, price: r.rate_price },
                to: r.rate_id || { name: r.rate_name, price: r.rate_price }
            })) || {};
    }

    getErrorCode({ code, field, message }) {
        // ERROR Replica Check handle here, waiting gofast to permit custom error
        if (code === 'missing-column') {
            return `missing-column:${field}`;
        }
        if (code === 'replica') {
            if (field.includes('buyer_')) {
                return 'TOO_MANY_BUYER';
            }

            if (field === 'payment_status') {
                return 'TOO_MANY_ORDER_STATUS';
            }
        }
        return message;
    }
}
